import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Button } from "../../shared/uikit/Button";
import { Typography } from "../../shared/uikit/Typography";
import { useHelpWidgetContext } from "../context/HelpWidgetContext";
import { useLeaveQueue } from "../hooks/useLeaveQueue";

export const LeaveQueueConfirmation = ({
  conversationId,
}: {
  conversationId: string;
}) => {
  const { mutate: leaveQueue } = useLeaveQueue();
  const { setIsShowingLeaveWarning, toggleWidget, leaveWarningTrigger } =
    useHelpWidgetContext();
  const history = useHistory();

  const handleStayInQueue = () => {
    setIsShowingLeaveWarning(false);
  };

  const handleLeaveQueue = () => {
    leaveQueue({ id: conversationId });
    setIsShowingLeaveWarning(false);

    if (leaveWarningTrigger === "back_button") {
      history.push("/conversations");
    } else {
      toggleWidget({ shouldTriggerOnWidgetClose: false });
    }
  };

  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center px-6 py-4">
      <div className="max-w-sm text-center">
        <div className="mx-auto mb-5 flex flex-col gap-2 px-5">
          <Typography.BodyLg
            weight="semibold"
            color="text-primary"
            size="text-xl"
          >
            {t("help_widget.live_chat.leave_chat.confirmation_title")}
          </Typography.BodyLg>
          <Typography.BodyMd weight="normal" color="text-tertiary">
            {t("help_widget.live_chat.leave_chat.confirmation_body")}
          </Typography.BodyMd>
        </div>

        <div className="mx-auto flex w-[140px] flex-col items-center gap-2">
          <Button
            variant="circle"
            onClick={handleStayInQueue}
            className="h-8 w-full px-4"
          >
            {t("help_widget.live_chat.leave_chat.keep_open_button")}
          </Button>
          <Button
            variant="secondary"
            onClick={handleLeaveQueue}
            className="h-8 w-full px-4"
          >
            {t("help_widget.live_chat.leave_chat.leave_queue_button")}
          </Button>
        </div>
      </div>
    </div>
  );
};
